module.exports = __webpack_public_path__ + "img/eye.2790f6c6.svg";